export default __webpack_public_path__ + "assets/images/c281bab4496257fa1170d3dd839710cc.png";